import API from "@/api/lib/api";

export const getAllQrCode = async (restaurant_id) => {
  try {
    const response = await API.get(`online-order/ordering/restaurant/${restaurant_id}/qr-codes`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleQrCode = async (item_id) => {
  try {
    const response = await API.get(`online-order/ordering/qr-codes/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createQrCode = async (data) => {  
  try {
    const response = await API.post(`online-order/ordering/qr-codes`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating qr-codes:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};

export const updateQrCode = async (item_id, data) => {
  try {
    const response = await API.put(`online-order/ordering/qr-codes/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleQrCode = async (id) => {
  try {
    const response = await API.put(
      `online-order/ordering/qr-codes/${id}/toggle`,
      {
        availability_type: 'website',
      }
    );
    return response.data;
  } catch (error) {    
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteQrCode = async (item_id) => {
  try {
    const response = await API.delete(`online-order/ordering/qr-codes/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
